// extracted by mini-css-extract-plugin
export default {"label":"select__label___1IKga","input":"select__input___1HuuQ","open":"select__open___2i3gh","flipped":"select__flipped___1i6x9"};